<template>
    <div v-if="lowTempMode?.state === WaterTempTrackerStateV1.LowTemp" class="lowTempMode">
        <v-icon size="large" icon="mdi-thermometer-low" />
        <div>
            <h3>Low Temp Mode</h3>
            <p>Slower timed sanitizer actions, SWG warnings for salt pools</p>
        </div>
    </div>
    <div v-else-if="lowTempMode?.state === WaterTempTrackerStateV1.EnteringLowTemp && lowTempMode.enteredLowTempModeDate" class="lowTempMode">
        <v-icon size="large" icon="mdi-thermometer-low" />
        <div>
            <h3>Entering Low Temp Mode</h3>
            <v-tooltip :text="formatDateForVesselTimezone({ date: lowTempMode.enteredLowTempModeDate, vesselTimezoneId })">
                <template v-slot:activator="{ props }">
                    <p class="date" v-bind="props">Started {{ formatDistanceToNowStrict(lowTempMode.enteredLowTempModeDate, { addSuffix: true }) }}</p>
                </template>
            </v-tooltip>
        </div>
    </div>
    <div v-else-if="lowTempMode?.state === WaterTempTrackerStateV1.ExitingLowTemp && lowTempMode.exitedLowTempModeDate" class="lowTempMode">
        <v-icon size="large" icon="mdi-thermometer-low" />
        <div>
            <h3>Exiting low temp mode</h3>
            <v-tooltip :text="formatDateForVesselTimezone({ date: lowTempMode.exitedLowTempModeDate, vesselTimezoneId })">
                <template v-slot:activator="{ props }">
                    <p class="date" v-bind="props">
                        Started {{ formatDistanceToNowStrict(lowTempMode.exitedLowTempModeDate, { addSuffix: true }) }}; Slower timed sanitizer actions, SWG
                        warnings for salt pools
                    </p>
                </template>
            </v-tooltip>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { type VesselStatusV1LowTempMode, WaterTempTrackerStateV1 } from '@geckoal/gecko-api-client'
import type { PropType } from 'vue'
import { formatDateForVesselTimezone } from '@/lib/utils'
import { formatDistanceToNowStrict } from 'date-fns'

defineProps({
    lowTempMode: {
        type: Object as PropType<VesselStatusV1LowTempMode>
    },
    vesselTimezoneId: {
        type: String
    }
})
</script>

<style lang="scss" scoped>
.lowTempMode {
    display: flex;
    flex-direction: row;
    align-items: center;

    background-color: rgb(170, 212, 229);
    padding: 20px;
    border-radius: 10px;
    color: rgb(26, 88, 113);

    .v-icon {
        margin-right: 12px;
    }
}

.date {
    &:hover {
        background-color: rgba(170, 212, 229, 0.5);
    }
}
</style>
